import React from 'react';
import styled from 'styled-components';
import { fontSize } from '../../mixins';
import PackageOptions from './PackageOptions';

const StyledOneTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 430px) {
    align-items: flex-start;
  }
`;

const StyledOneTimeTitle = styled.div`
  font-weight: 700;
  ${fontSize(24)};
  line-height: 100%;
  letter-spacing: -0.46px;
  color: #ffffff;
  margin-bottom: 16px;
  text-transform: uppercase;
  text-align: center;
`;

const StyledOneTimePrevPrice = styled.div`
  font-weight: 500;
  ${fontSize(16)};
  line-height: 100%;
  letter-spacing: -0.46px;
  text-decoration-line: line-through;
  text-transform: uppercase;
  color: #ffffff;
  margin-bottom: 8px;
`;

const StyledOneTimePrice = styled.div`
  font-weight: 800;
  ${fontSize(32)};
  line-height: 100%;
  letter-spacing: -0.46px;
  text-transform: uppercase;
  color: #ffffff;
`;

const OneTimeListWrapper = styled.div`
  min-width: 370px;
  margin-top: 100px;
  margin-bottom: 120px;
  @media screen and (max-width: 430px) {
    padding: 10px;
    min-width: unset;
    margin-top: 30px;
    margin-bottom: 30px;
  }
`;

const StyledOneTimeList = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
`;

const StyledOptionsWrapper = styled.div`
  margin-top: 45px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

const OneTimePlan = ({ currentPlans }) => {
  const { title, prevPrice, period, weeklyPrice } = currentPlans[0];

  return (
    <OneTimeListWrapper>
      <StyledOneTimeList>
        <StyledOneTimeWrapper>
          <StyledOneTimeTitle>{title}</StyledOneTimeTitle>
          <StyledOneTimePrevPrice>
            {prevPrice} / {period}
          </StyledOneTimePrevPrice>
          <StyledOneTimePrice>
            {weeklyPrice} / {period}
          </StyledOneTimePrice>
        </StyledOneTimeWrapper>
      </StyledOneTimeList>
      <StyledOptionsWrapper>
        <PackageOptions active />
      </StyledOptionsWrapper>
    </OneTimeListWrapper>
  );
};

export default OneTimePlan;
